module.exports = __webpack_public_path__ + "media/images/shared/icon_pinterest-039661a27fbf9dd1fb4c0a0c1fda70aa.png";